import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Notifications_mark_as_read extends PureComponent {
  render() {
    return (
      <div className="row" id="notifications_mark_as_read">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Mark Notification as Read</h2>
              <p>
                Notifications are automatically marked as read when they're
                clicked on in the Nexoid interface. You can programmatically
                mark single or all notifications as read using this function.
                Once a notification is marked as read it will automatically be
                deleted after 24 hours.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Mark Notification as Read Example</h2>
            </section>
            <section>
              <h3>Example 1: Mark Single Notification as Read</h3>
              <p>
                This example will mark a notification with the ID of 35 as read.
              </p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodeDELETE">DELETE</span> - https://
                <span className="jsonY">example</span>
                .api.nexoid.com/v1/notification/
                <span className="jsonY">35</span>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                </div>
                <div>&#125;</div>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123; &#125;</div>
              </div>
            </section>
            <section>
              <h3>Example 2: Mark All Notifications as Read</h3>
              <p>This example will mark all notifications as read.</p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodeDELETE">DELETE</span> - https://
                <span className="jsonY">example</span>
                .api.nexoid.com/v1/notification/all
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                </div>
                <div>&#125;</div>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123; &#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Notifications_mark_as_read;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Notifications_mark_as_read.js